/* jshint -W072 */ // TODO: fix max params violation. Remove $cancelableResourceManager by moving into student api layer.  Student overview is a complex page, so max params violation may be unavoidable.
(function () {
    angular.module('rightPaneModule')
      .controller('GuardianOverviewController', [
          '$log',
          '$scope',
          '$state',
          '$timeout',
          '$modal',
          'moment',
          'studentApi',
          'timeframe',
          'authentication',
          'configuration',
          'customer',
          'navigation',
          'dblUserAgent',
          'dblProficiencyApi',
          'reportErrors',
          'dblProductResourcesService',
          'dblStudentMilestonesService',
          'dblUsageFactory',
          'assignedFocusApi',
          'activityApi',
          'edxReportItemService',
          'PendoService',
          GuardianOverviewController]);

    function GuardianOverviewController(
      $log,
      $scope,
      $state,
      $timeout,
      $modal,
      $moment,
      $studentApi,
      $timeframe,
      dblAuthentication,
      configuration,
      dblCustomerService,
      dblNavigationService,
      dblUserAgent,
      dblProficiencyApi,
      dblReportErrors,
      dblProductResourcesService,
      dblStudentMilestonesService,
      dblUsageFactory,
      $assignedFocusApi,
      $activityApi,
      edxReportItemService,
      pendoService
    ) {
        pendoService.initialize();

        $scope.getColorByStatus = getColorByStatus;
        $scope.getStudentName = getStudentName;

        $scope.years = {list: null, selected: {}};
        $scope.timeframes = {
            list: [
                {id: '1d', name: 'Today', by: 'day', active: false},
                {id: '7d', name: 'Last 7 Days', by: 'day', active: true},
                {id: '30d', name: 'Last 30 Days', by: 'week', active: false}
            ],
            selected: {}
        };

        function updateActivities() {
            $scope.displayWarning = !$timeframe.isWithinDays(30);
            var timeframeWithin30 = $timeframe.getTimeframeWithinDays(30);

            if (!timeframeWithin30) {
                // timeframe doesn't overlap last 30 days at all, so don't bother requesting activities
                $scope.milestones = undefined;
                $scope.milestonesMessage = dblStudentMilestonesService.NO_ACTIVITY_MESSAGE;
                return;
            }

            var days = timeframeWithin30.days;
            var fd = timeframeWithin30.fd;
            var td = timeframeWithin30.td;

            // reset infinite scrolling if active
            $state.current.data.next_page = undefined;
            $scope.milestonesMessage = undefined;

            $activityApi.getStudentActivitiesForGuardian(days, fd, td, true).then(function (data) {
                $scope.milestones = dblStudentMilestonesService.getMilestones(data.activities);
                if (!$scope.milestones.length) {
                    $scope.milestonesMessage = dblStudentMilestonesService.NO_ACTIVITY_MESSAGE;
                }
            }, function (error) {
                $scope.milestones = undefined;
                $scope.milestonesMessage = dblReportErrors.getErrorMessage(error, 'Unable to load activity.');
            });
        }

        function updateEngagementActivities() {
            var districtId = $state.params.studentDistrictId;
            var studentId = $state.params.studentId;
            $scope.engagementActivitiesError = null;
            $scope.engagementEvents = undefined;
            $activityApi.getStudentEngagementActivity(districtId, studentId).then(function (data) {
                $scope.engagementEvents = data.events;
            }, function (error) {
                var msg = dblReportErrors.getErrorMessage(error);
                if (!msg) {
                    msg = 'Unable to load student achievements.';
                }

                $scope.engagementActivitiesError = msg;
            });
        }

        function updateMode() {
            $scope.viewMode = dblAuthentication.growthAsFraction() ? 'fractionMode' : 'percentMode';
        }

        function isAssignmentActive(assignment) {
            return assignment.status === 'ACTIVE' && !_.startsWith(assignment.student_status, "COMPLETE") &&
              !_.startsWith(assignment.student_status, "REMOVED");
        }

        function updateAssignments() {
            $scope.assignments = undefined;
            $assignedFocusApi.getStudentAssignedLessonsHistory($state.params.studentId, function (history) {
                history = history.assignments;

                $scope.assignments = _.filter(history, function (assignment) {
                    return isAssignmentActive(assignment);
                });

                return $assignedFocusApi.appendFocusData($scope.assignments);
            });
        }

        function viewProgressClicked(e, assignment) {
            var modal = $modal.open({
                templateUrl: 'resources/core/partials/student-progress-modal.html',
                windowClass: 'fill-view-modal student-progress-modal',
                controller: 'StudentProgressModalController',
                backdrop: 'static',
                scope: $scope,
                resolve: {
                    progressData: function () {
                        var data = $assignedFocusApi.createProgressDataFromAssignment(assignment);
                        data.grade = $scope.studentData.grade_level;
                        data.districtId = $state.params.studentDistrictId;

                        return data;
                    }
                }
            });
        }

        function updateStudentData(studentHighlights) {
            updateMode();
            updateAssignments();
            updateActivities();
            updateEngagementActivities();

            var districtId = $state.params.studentDistrictId;
            var studentId = $state.params.studentId;
            $studentApi.getStudentDataForGuardian(studentId, districtId).then(function (studentHighlights) {
                $scope.showAlerts = studentHighlights.status_reason_codes && studentHighlights.status_reason_codes.length > 0 && $timeframe.isRecent();
                $scope.statusReasonCodes = studentHighlights.status_reason_codes;
            });

            var studentReportingPromise = $studentApi.getStudentsReportingForGuardianStudent();
            studentReportingPromise.then(function (studentData) {
                $scope.usageData = dblUsageFactory.extractUsageData(studentData);
                $scope.displayAverages = $timeframe.getDaysInSelectedPeriod() > 7;
                $scope.studentData = angular.copy(studentData);
                $scope.gradeLevel = studentData.grade_level;
                $scope.growthStandardsNames = {
                    completed: studentData.standards_growth_names,
                    inProgress: studentData.standards_partial_growth_names
                };

                // Swap trial banner data to match the selected student.
                $scope.childName = studentData.first_name;
                if ($scope.trialDaysPerStudent) {
                    $scope.trialDaysLeft = $scope.trialDaysPerStudent[studentData.id] || 0;
                }

                // Sort the grades array by ordinal because we can't assume it will come back pre-sorted
                $scope.studentData.grades = _.sortBy($scope.studentData.grades, function (o) {
                    return o.ordinal;
                });
            });

            var ast = dblCustomerService.getAcademicStandard().academic_standard_name;
            var days = $timeframe.parseNumber('day');
            days = isFinite(days) ? days : undefined;
            var sy = $timeframe.parseNumber('year');
            sy = isFinite(sy) ? sy : undefined;
            var fd = $timeframe.getFromDate();
            var td = $timeframe.getToDate();
            var includesThePresent = $timeframe.includesThePresent();
            updateProficiencyTable(districtId, studentId, ast, days, sy, fd, td, includesThePresent);
        }

        function updateProficiencyTable(districtId, studentId, ast, days, sy, fd, td, includesThePresent) {
            $scope.proficiencyOverviewError = undefined;
            $scope.proficiencyTable = undefined;
            $scope.proficiencyDateMessage = undefined;

            dblProficiencyApi.getStudentDomainTable(districtId, studentId, ast,
              days, sy, fd, td, includesThePresent).then(function (proficiencyTable) {

                $scope.proficiencyTable = proficiencyTable;
                $scope.proficiencyDateMessage = $timeframe.getPrettyProficiency();
            }, function (error) {
                var msg = dblReportErrors.getErrorMessage(error);
                if (!msg) {
                    msg = 'Unable to load proficiency data.';
                }

                $scope.proficiencyOverviewError = msg;
            });
        }

        function getColorByStatus(columnId, row) {
            if (typeof row !== 'undefined' && row[columnId + '_status'] === 2) {
                return 'text-warn';
            } else if (typeof row !== 'undefined' && row[columnId + '_status'] === 1) {
                return 'text-congratulate';
            }
        }

        // TODO: duplicated in student/overview.js
        function createGrades(gradeRecords) {
            return _.map(gradeRecords, function (grade) {
                return {
                    grade: grade.grade,
                    gradeLevel: grade.grade_level,
                    id: grade.id,
                    name: grade.name,
                    standardsCompleted: grade.standards_completed,
                    standardsCount: grade.standards_count
                };
            });
        }

        function initializeData(item) {
            $log.debug('Receiving item');
            $scope.item = item;

            updateMode();

            var customer = dblAuthentication.getCustomer();
            $scope.efpEnabled = customer.hasTag('INSIGHT_EFP');
            $scope.hideStudentPlacement = !configuration.isFeatureEnabled('student_proficiency_grid_placement_enabled');
            // Guardians always see assignments, but can only make assignments if
            // tagged with assign_focus_enabled.
            // Apparently there's a difference between the assign_focus_enabled tag
            // and the assign_focus_enabled customer property.  For guardians the customer property is
            // always true, which is what governs that assignments are always shown.
            $scope.canAssignLessons = customer.hasTag('ASSIGN_FOCUS_ENABLED');

            $scope.trialDaysPerStudent = customer.user_trial_days_remaining;

            $scope.productPlanUrl = dblProductResourcesService.getSubscriptionInfoUrl();

            if (!$state.params.timeframe) {
                $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by);
            }
        }

        function getStudentName() {
            if (!$scope.studentData) {
                return '';
            }

            return $scope.studentData.first_name + ' ' + $scope.studentData.last_name;
        }

        $scope.$watch(function () {
            return $state.params.studentDistrictId + '-' + $state.params.studentId;
        }, function () {
            if ($state.params.studentDistrictId && $state.params.studentId) {
                $log.debug('State params changed (studentDistrictId, studentId)');
                updateStudentData();
            }
        });

        $scope.$on('updateYears', function (e, years) {
            $scope.years.list = angular.copy(years);
        });

        $log.debug('Subscribing to item');
        var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);
        $scope.$on('$destroy', function () {
            itemSubscription.dispose();
        });

        $scope.$on('timeframeSelected', function () {
            $log.debug('overview - timeframeSelected');
            updateStudentData();
        });
        $scope.$on('viewProgressClick', viewProgressClicked);
    }
})();
/* jshint +W072 */

